module.exports = __webpack_public_path__ + "media/assets/images/blog/plc-small-28d5b7b2be7d38c9df73837961a0e5b2.jpeg";